export default __webpack_public_path__ + "static/media/sienas8-min.c26a1e67.jpg";